import {
  defaultFetchHeaders,
  defaultReadHeaders,
  fetchJson,
} from "../../utils";
import { ApiResponseError } from "../../apiError";
import { GROWTH_CHANGED } from "./types";
export { GROWTH_CHANGED } from "./types";
const base = `${process.env.REACT_APP_BACKEND_URL || ""}/growth`;

export const readGrowth = <T>(path: string, signal?: AbortSignal) =>
  fetchJson<T>(
    `${base}${path}`,
    {
      credentials: "include",
      headers: defaultReadHeaders(),
      signal,
    },
    "Unable to load Growth data.",
  );

export async function changeGrowth<T>(
  path: string,
  method: "POST" | "PATCH" | "DELETE",
  data: object,
  notify = true,
): Promise<T> {
  const result = await fetchJson<T>(
    `${base}${path}`,
    {
      method,
      credentials: "include",
      headers: await defaultFetchHeaders(),
      body: JSON.stringify(data),
    },
    "Unable to save Growth changes.",
  ).catch(error => {
    if (error instanceof ApiResponseError && error.status === 409)
      window.dispatchEvent(new CustomEvent(GROWTH_CHANGED, { detail: { path } }));
    throw error;
  });
  // Only endpoints returning the complete lead can replace its detail cache.
  const leadPath = path.match(
    /^\/leads\/([^/]+)\/(?:star|details|description|business-information|contacts|photos(?:\/[^/]+)?)$/,
  );
  if (notify)
    window.dispatchEvent(
      new CustomEvent(GROWTH_CHANGED, {
        detail: path === "/settings" ? { path, data: result } : leadPath
          ? { path: `/leads/${leadPath[1]}`, data: result }
          : { path },
      }),
    );
  return result;
}

export async function uploadGrowthPhoto(
  leadId: string,
  file: File,
  caption: string,
  notify = true,
) {
  const body = new FormData();
  body.append("file", file);
  body.append("caption", caption);
  const headers = await defaultFetchHeaders();
  delete (headers as Record<string, string>)["Content-Type"];
  const result = await fetchJson(
    `${base}/leads/${encodeURIComponent(leadId)}/photos`,
    { method: "POST", credentials: "include", headers, body },
    "Unable to upload lead photo.",
  );
  if (notify)
    window.dispatchEvent(
      new CustomEvent(GROWTH_CHANGED, {
        detail: { path: `/leads/${leadId}`, data: result },
      }),
    );
  return result;
}
